<template>
  <div class="main-container" style="height: 100vh; overflow-y: scroll">
    <!-- add-new-modal -->
    <modal :height="250" :pivotY="0.5" :width="300" name="add-new-suggestion">
      <div class="text-xs-center add-tag-container">
        <h3>Type the tag name!</h3>

        <v-text-field color="#f5a623" v-model="addTagModal" :autofocus="true" />

        <button class="tag-add-button" @click="addTagToSelected()">Add Tag</button>
      </div>
    </modal>
    <!-- /add-new-modal -->

    <!-- sec 1 (header) -->
    <div class="head-section">
      <!-- /action -->
      <div class="actions">
        <div>
          <i class="material-icons white--text" @click="$modal.hide('suggestions')">arrow_back_ios</i>
        </div>
        <div class="done" @click="emitArrayAsTextObjArr()">Done</div>
      </div>
      <!-- /action -->

      <!-- head-->
      <div class="head">
        <div>{{headTag}}</div>
        <div>{{subheadTag}}</div>
      </div>
      <!-- /head-->
    </div>
    <!-- /sec 1 (header) -->

    <!-- sec 2 (input) -->
    <div class="input-section" style="position: relative">
      <!-- input-header -->
      <div class="input-header">Your input</div>
      <!-- /input-header -->

      <!-- bg clickable -->
      <div @click="$modal.show('add-new-suggestion')" class="clickable-modal-bg"></div>
      <!-- /bg clickable -->

      <!-- add-new -->
      <button
        class="add-new-btn-suggestion pointer"
        @click="$modal.show('add-new-suggestion')"
      >Add new</button>
      <!-- /add-new -->

      <!-- selected suggestions -->
      <div class="selected-suggestions">
        <!-- shows if arr is empty -->
        <div
          class="default-text"
          v-if="selectedSuggestions.length === 0"
        >Add a new one or select from the suggestions below.</div>

        <div class="suggestions-container" v-else>
          <button
            v-for="(suggestion,sIndex) in selectedSuggestions"
            :key="`${sIndex}`"
            @click="addOrRemove(suggestion)"
            class="added-suggestions"
          >
            <i class="material-icons">
              {{
              selectedSuggestions.includes(suggestion)?
              'cancel': 'add'}}
            </i>
            {{suggestion}}
          </button>
        </div>
      </div>
      <!-- /selected suggestions -->
    </div>
    <!-- /sec 2 (input) -->

    <!-- sec 3 (suggestions) -->
    <div class="suggestion-section white--text">
      <div class="suggestion-head">SUGGESTIONS</div>

      <!-- suggestion arr -->
      <div class="suggestions-container">
        <div v-for="(suggestion, sIndex) in suggestions" :key="`${sIndex}`">
          <button
            @click="addOrRemove(suggestion)"
            :class="selectedSuggestions.includes(suggestion)?
             'selected-suggestion': 'unselected-suggestion'"
          >
            <i class="material-icons">
              {{
              selectedSuggestions.includes(suggestion)?
              'cancel': 'add'}}
            </i>
            {{suggestion}}
          </button>
        </div>
      </div>
      <!-- /suggestion arr -->
    </div>
    <!-- /sec 3 (suggestions) -->
  </div>
</template>
<script>
let vm;
export default {
  methods: {
    emitArrayAsTextObjArr() {
      // console.log("Modal Will be closing now!!! :O");
      let arr = [];
      for (let i in this.selectedSuggestions) {
        arr.push(this.selectedSuggestions[i]);
      }
      let payload = {
        arr,
        tagCatType: vm.suggestionTag
      };
      this.$emit("arrayval", payload);
      this.$modal.hide("suggestions");
    },
    //
    addOrRemove(suggestion) {
      if (this.selectedSuggestions.includes(suggestion)) {
        let ind = this.selectedSuggestions.indexOf(suggestion);
        this.selectedSuggestions.splice(ind, 1);
      } else {
        this.selectedSuggestions.push(suggestion);
      }
    },
    //
    addTagToSelected() {
      let re = /^$/;
      console.log({ RE_TEST_VAL: re.test(this.addTagModal) });
      if (!re.test(this.addTagModal)) {
        this.selectedSuggestions.push(this.addTagModal);
        this.addTagModal = "";
        this.$modal.hide("add-new-suggestion");
      } else {
        this.$store.commit("snackbar_alert", { msg: "Tag cannot be empty!" });
      }
    }
  },
  //
  data() {
    return {
      addTagModal: "",
      selectedSuggestions: [],
      suggestions: []
    };
  },
  //
  props: ["arr", "suggestionTag", "headTag", "subheadTag"],
  async created() {
    vm = this;

    if (vm.suggestionTag === "keywords") {
      let res = await this.$store.dispatch("getImaggaSuggestions", {
        publicId: this.$route.query.publicId
      });
      // console.log({ RES: res });
      for (let i in res.tags) {
        this.suggestions.push(res.tags[i].tag);
      }
    }

    for (let i in this.arr) {
      this.selectedSuggestions.push(this.arr[i]);
    }
    // console.log({ suggestionTag: vm.suggestionTag });
    let res = await this.$store.dispatch("GET_SUGGESTIONS", {
      tagCatType: vm.suggestionTag
    });
    // console.log({ res });

    //
    for (let i in res.tags) {
      if (res.tags[i].tag !== "all") {
        this.suggestions.push(res.tags[i].tag);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/upload/suggestion";
</style>



// WEBPACK FOOTER //
// suggestion-model.vue?3bf1994c